import type {ProcessFileModel} from '../../../shared/models';
import {EstadoCivilDocTypeExtractedView} from './EstadoCivilDocTypeExtractedView';
import {IdentificacaoDocTypeExtractedView} from './IdentificacaoDocTypeExtractedView';
import {RendaDocTypeExtractedView} from './RendaDocTypeExtractedView';
import {ResidenciaDocTypeExtractedView} from './ResidenciaDocTypeExtractedView';

export type SimplifiedDocType = 'IDENTIFICACAO' | 'RENDA' | 'RESIDENCIA' | 'ESTADO_CIVIL' | 'OUTRO';

export function normalizeDocType(docType: string | null | undefined): SimplifiedDocType {
    const normalized = (docType ?? '').trim().toUpperCase();
    if (normalized === 'IDENTIFICACAO' || normalized === 'IDENTIFICATION') return 'IDENTIFICACAO';
    if (normalized === 'RENDA' || normalized === 'INCOME_PROOF') return 'RENDA';
    if (normalized === 'RESIDENCIA' || normalized === 'RESIDENCE_PROOF') return 'RESIDENCIA';
    if (normalized === 'ESTADO_CIVIL' || normalized === 'ESTADO CIVIL' || normalized === 'MARITAL_STATUS') {
        return 'ESTADO_CIVIL';
    }
    return 'OUTRO';
}

type ProcessFileTypeExtractedViewProps = {
    file: ProcessFileModel;
};

export function ProcessFileTypeExtractedView({file}: ProcessFileTypeExtractedViewProps) {
    const diagnostico = file.ai_diagnosis;
    const docType = normalizeDocType(file.doc_type);
    const extractedData = file.extracted_data;
    const docSubtype = file.doc_subtype;
    const docSubtypeText = file.doc_subtype_text;

    if (docType === 'IDENTIFICACAO') {
        return (
            <IdentificacaoDocTypeExtractedView
                extractedData={extractedData}
                diagnostico={diagnostico}
            />
        );
    }

    if (docType === 'RENDA') {
        return (
            <RendaDocTypeExtractedView
                extractedData={extractedData}
                diagnostico={diagnostico}
                docSubtype={docSubtype}
                docSubtypeText={docSubtypeText as string | null | undefined}
            />
        );
    }

    if (docType === 'RESIDENCIA') {
        return (
            <ResidenciaDocTypeExtractedView
                extractedData={extractedData}
                diagnostico={diagnostico}
            />
        );
    }

    if (docType === 'ESTADO_CIVIL') {
        return (
            <EstadoCivilDocTypeExtractedView
                extractedData={extractedData}
                diagnostico={diagnostico}
            />
        );
    }

    return (
        <p className="font-instrument text-xs text-textSecondary italic">
            Nenhum resumo de dados extraídos disponível para este arquivo.
        </p>
    );
}
